export const getCountOfEpisodes = (serial) => {
  if (serial.seasons !== undefined) {
    let episode = serial.seasons.reduce(
      (acc, item) => acc + item.episodes.length,
      0
    );
    return episode;
  }
};
